import { currencyScale } from '@wit-support/admin-contracts';
/**
 * Locale to format each currency in, so e.g. RUB renders with the trailing
 * `₽` and a comma decimal separator instead of the `Intl` default for the
 * runtime's locale. Falls back to `ru-RU` for any currency not listed here —
 * this admin panel's primary audience — rather than the browser/Node locale.
 */
const CURRENCY_LOCALE = {
    USD: 'en-US',
    EUR: 'en-IE',
    GBP: 'en-GB',
    RUB: 'ru-RU',
};
// Таблица знаков валют и `currencyScale` живут в `@wit-support/admin-contracts` (одна таблица на
// админку и MCP: модель получает `minorExponent` из неё же, M-5 P1-2); здесь — реэкспорт.
export { currencyScale };
/** minor units → сумма в валюте (2500 USD → 25; 2500 JPY → 2500). */
export function minorToMajor(minor, currency) {
    return minor / 10 ** currencyScale(currency);
}
/** Сумма в валюте → minor units с округлением до минимальной единицы. */
export function majorToMinor(major, currency) {
    return Math.round(major * 10 ** currencyScale(currency));
}
/**
 * Format an integer minor-unit amount into a currency string, e.g.
 * `(2997, 'usd')` → `$29.97`, `(1234, 'jpy')` → `¥1 234`. Money stays in minor
 * units end-to-end; this is the UI edge.
 */
export function formatMoney(minorUnits, currency) {
    const code = currency.toUpperCase();
    const locale = CURRENCY_LOCALE[code] ?? 'ru-RU';
    const scale = currencyScale(code);
    const amount = minorUnits / 10 ** scale;
    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: code,
            minimumFractionDigits: scale,
            maximumFractionDigits: scale,
        }).format(amount);
    }
    catch {
        // Unknown / malformed currency code — fall back to a plain decimal.
        return `${amount.toFixed(scale)} ${code}`;
    }
}
//# sourceMappingURL=format-money.js.map